import { useMutation } from '@apollo/client';
import {
  GET_PUSH_NOTIFICATION_CAPABILITY_QUERY,
  UPSERT_PUSH_NOTIFICATION_SUBSCRIPTION_MUTATION,
} from 'src/graphql/entities/push-notification/push-notification.operations';
import { PushNotificationSubscription } from './use-push-notification-capability';

type UpsertPushNotificationSubscriptionInput = {
  endpoint: string;
  authKey: string;
  p256dhKey: string;
  expirationTime?: string | null;
  userAgent?: string | null;
};

type UpsertPushNotificationSubscriptionMutation = {
  upsertPushNotificationSubscription: PushNotificationSubscription;
};

export const useUpsertPushNotificationSubscription = () => {
  const [mutate, { loading }] = useMutation<
    UpsertPushNotificationSubscriptionMutation,
    { input: UpsertPushNotificationSubscriptionInput }
  >(UPSERT_PUSH_NOTIFICATION_SUBSCRIPTION_MUTATION, {
    refetchQueries: [GET_PUSH_NOTIFICATION_CAPABILITY_QUERY],
  });

  return {
    upsertPushNotificationSubscription: (input: UpsertPushNotificationSubscriptionInput) =>
      mutate({ variables: { input } }),
    loading,
  };
};
